module.exports = __webpack_public_path__ + "static/media/icon_approvalHistory.d7198038.svg";